import { Permissions } from 'types/Permissions';

export const DefaultPermissions: Permissions = {
  canDelete: false,
  canEdit: false,
  canView: true,
};
